<template>
	<div id="account-app" class="ss-account" v-loading="!appReady">
		<el-alert type="error" v-if="serverError">
			{{serverError}}
		</el-alert>

		<router-view v-if="appReady"/>
		
	</div>
</template>

<script>

	import { mapActions, mapGetters } from "vuex";

	export default {
		data() {
			return {
				ready: {
					user: false,
					payment: false,
					configuration: false
				},
				serverError: null
			}
		},

		created() {
			this.fetchConfiguration();
			this.fetchUser();
			//this.fetchPayment();
			this.modalWidth();
			window.addEventListener("resize", this.modalWidth);

			
		},

		components: {			
			
		},

		
		methods: {

			...mapActions({
				getUser: "getUser",
				getPayment: "getPayment",
				getConfiguration: "getConfiguration"
			}),

			modalWidth() {
				if (window.innerWidth < 600) {
					this.$store.commit("setDialogWidth", "90%");
				} else {
					this.$store.commit("setDialogWidth", "60%");					
				}
			},

			fetchConfiguration() {
				this.getConfiguration().then(() => {

				}, error => {
					this.serverError = error;
				}).finally(() => {
					this.ready.configuration = true;				
				});
								
			},

			fetchUser() {
				this.getUser(window.sunstonevNext.apps.account.data.urlId).then(response => {

				}, error => {
					this.serverError = error;
				}).finally(() => {
					this.ready.user = true;				
				});
								
			},

			fetchPayment() {
				
				//this.getPayment(window.sunstonevNext.apps.account.data.urlId).then(response => {

				//}, error => {
				//	this.serverError = error;
				//}).always(() => {
				//	this.ready.payment = true;
				//});
			}
		},

		computed: {
			...mapGetters({
				user: "user",
				payment: "payment"
			}),


			appReady() {
				return this.ready.user && this.ready.configuration;
			}
		}
	}
</script>

<style>
	#app {
		min-height: 400px;
	}
	.fade-enter-active,
	 .fade-leave-active {
		 transition-duration: 0.3s;
		transition-property: height, opacity;
		 transition-timing-function: ease;
		overflow: hidden;
	 }

	.profile-wrapper .account-header {

	}

	.profile-wrapper h2 {
		font-size: 18px;
		color:#cc6600; 
	}

	.el-dialog__body {    
    word-break: break-word;
	}

	.el-button--primary.is-active, .el-button--primary:active, el-button--primary:focus {
    background: #cc6600;
    border-color: #cc6600;
    color: #FFF;
	}

	.el-button--primary {
    color: #FFF;
    background-color: #cc6600;
    border-color: #cc6600;
	}

	.el-button--primary:hover {
    color: #FFF;
    background-color: #cc6600;
    border-color: #cc6600;
		opacity: .9;
	}

	.el-alert--info.is-dark span {
    color: #ffffff !important;
	}

	.el-message {
		min-width: 340px !important;
	}
	
	.has-error input,
	.has-error select {
		border-color: red;
	}

	.account-header {
		position: relative;
	}

		.account-header .action {
			position: absolute;
			font-size: 25px;
			right: 0;
			top: 13px;
			cursor: pointer;
		}

	.el-button+.el-button {
    margin-left: 0px;
	}

	.el-dialog {
		margin-top: 5vh !important;
	}

	.el-message-box {
		width: 320px;
	}

	/* Small devices (landscape phones, 576px and up) */
	@media (min-width: 576px) {

		.el-message-box {
			width: 480px;
		}

		.el-button + .el-button {
			margin-left: 15px;
		}

		.profile-wrapper h2 {
			font-size: 26px;
			font-weight: 300;
		}
	}

	/* Medium devices (tablets, 768px and up) The navbar toggle appears at this breakpoint */
  @media (min-width: 768px) {  
 
  }
 
  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) { 
		
  }
 
  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {  
    
  }
</style>
